var _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinepay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 48,
    viewBox: "0 0 46 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.759766,
    width: 45,
    height: 47.9508,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_472_11402",
    transform: "scale(0.0163934 0.0153846)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_472_11402",
    width: 61,
    height: 65,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAD0AAABBCAYAAABigqxTAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAABBNJREFUeNrsWjtoFEEYHo8UQQJeESGFmCssIkg8sbHJw0ZthGhhYw60MDYRTZEqggmYysKIaYxFhGxlYXw0auPlUotnEIyQ4hIsAgZyQtAUQpzv3Ilzf2Yzs6+729v9YAiX2Z2d7/+//zF7x9h/bPKxI415Zo4suRfjmjQ/r5i/E/B6urHLJyUtlCYPTrsgrbo2o5l/aJMLaj3jPaZYfTFbj4fWm3TW9nhN0cLqD8T2Kz7yPtfR3f+okUgLmZ/io+xjjbNRkbecpGbjJG+BAXu89Hj/uGYe6xbrTbpEypCQedHjevc0830iBOop70sOtTR0mdeTNDw6ofh/Px+3m7lOjzvIeSCEZ5UbKZFB5p88tpZuSlaxkUiXbJn77czyUZG3wFQAHVkgMd2vOapt2tcEKXM/HZnuaDkehKfTAZMG4eshOriv0eQtd03Pmv1oqcKIndxqQjrvQY55KQOXyJxcfxdcZNqyHd9u1jPBAkuQIEGCBBHGgdYPV7P2W4d0DPii9E3glIWvOzIxcnQ2FTPCQCYVx5hOSCekE9IJ6cjD6G3o8pkp1tnarpxb3d5gS1ur7M3GRza3XohMR7aju+h3v2W0GMifK06yn39+xUfe3W2d7H12jB1qORivmAbxW0cuRD+mKUZXrIqUAXj1adfNKu8OdvSy+6UXyns7Ww9X8gNywer2j+iQBuFC+WuVEWa6hiRie5PeMPc+hjwH4qMrcyzHjSQbbWh5pmKQi+2nK/cIIFdc+bL32x/cP9jRs/t5ke/NyeieSe/N4Pt7bIYrISdtSjbO8xMjyv9jzaWtNdabPl41h8+ywYGxzOUqYy6S+VBiGh5xwl2+IRVhU2NSgggd+myqrLn1xeDljQcLD/Twv9QbYqOIX3iBQsyf5ElPl+ktTkBeHwZESIiymCNGQL+gU54n0jrPTdrxRBWAjaKO0yS4n1LQ8FD5ojogZmFUeq9JgxR4yZr+/nbXk1QB2JAgLIyAJKiDRYgIiVPjIzHC0zUjDQLIujIJKl3VhkzKFo1ReB0epvFtGbbBnuSNTaxJm/1s9946qDKvSfcGw2B9Wcq0NzBJYL5Iw6IFTVkQpUOWOGruYy5/uTd/cCxnHDYyaZWKTJudUH9z8ppvRM7e2Og3fmJDbIO4KvM7AUZGzDqd9tyc8EI9Ty8pZA/i8DiMYUpY9rbT8dYkvGr2EuHG8pOqjO0HTt60XJ7jjUjT83HZxXlZ1GanJDNNYny/9XGdah3TBObqJUJQQDPR3Xa00okh46O3dnvSon08Yv08N2ropyw/BxNRfrwA+YA2JJZLL9ckpoME7bP/yb3Q3KSHyRsZry8iI0NavHGpToLvPK1V00TWKEi+4UhIJ6Sbj3QpZpxL6Mjw49NY/brorwADAChUxPe5GTvbAAAAAElFTkSuQmCC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinepay);
export default __webpack_public_path__ + "static/media/linepay.66b37b81bbed57840beaa889ee408f6f.svg";
export { ForwardRef as ReactComponent };